
if (isNullOrUndefined(sumo)) {
    throw ('GoogleMapControl.js requies the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.maps)) {
    sumo.maps = {};
}

if (isNullOrUndefined(google) || isNullOrUndefined(google.maps)) {
    throw ('GoogleMapControl.js requires Google Maps 3.x found here: https://maps.googleapis.com/maps/api/js?libraries=geometry,drawing,places&sensor=true');
}

function log(aMessage, aDoAppend) {
    "use strict";
    if (aDoAppend) {
        $('#uDebugOutput').text($('#uDebugOutput').text() + ' ' + aMessage);
    } else {
        $('#uDebugOutput').text(aMessage);
    }
}

// ---------------------------------------------------------
// sumo.maps.GoogleMapControl
// ---------------------------------------------------------

// public methods
// --- MAP
//  setCenter()
//  fitBounds()
//  render()
// options
//  optional displayType: satellite, roadmap, hybrid (default)

// --- LAYERS
//  layerAdd(aLayerName, aOptions:
//    {optional renderType = 'marker', 
//    optional doesPlayback = false,
//    optional isVisible = false,
//    optional isClickable = true,
//    optional clickEventHandler = null,
//    optional zIndexStart = 0,
//    optional dataSource = null})
//      aRenderType:
//          'marker'
//          'geometry'
//          'linesegment'
//          'label'
//      aDoesPlayback: if true then the dataset will be played back point by point
//      aIsVisible: if true then the layer will be immediately rendered
//      aDataSource: the dataset that defines the points
//          'marker': dataitem: {latitude, longitude, iconUri, anchor[x,y], data, doHover, hoverHtml, hoverCssClass, hoverVerticalOffset, hoverHorizontalOffset}
//          'geometry': dataitem: { [latitude, longitude], cssClass, hoverHtml, data}
//          'linesegment': dataitem: { segments[latitude, longitude], hoverHtml, data} - sort order matters
//          'label': dataitem: {latitude, longitude, text, cssClass, data, verticalOffset, horizontalOffset} - sort order matters
//  layerRemove(aLayerName)
//  layerShow(aLayerName)
//  layerHide(aLayerName)
//  layerSetDataSource(aLayerName, aDataset)
//  layerSetRenderType(aLayerName, aRenderType)
//      aRenderType:
//          'marker'
//          'geometry'
//          'linesegment'
//          'Label'
//          'label'
//  layerSetDoesPlayback(aLayerName, aDoesPlayback)

//function GoogleMapControl(aId, aParentId, aOptions) {
sumo.maps.GoogleMapControl = function (aId, aParentId, aOptions) {
    "use strict";

    sumo.maps.GoogleMapControl.prototype.baseClass.call(this, aId, aParentId, '<div class="sumo-googlemap" style="width:100%; height:100%" id="##id##"></div>', aOptions);

    var mMap = null,
        mLayers = {},
        mDisplayType = 'hybrid',
        mMapTypeId_OnChange = null,
        mMap_OnClick = null,
        mMap_OnRightClick = null,
        mThis = this,
        mHeatMap = null,
        mHeatMapData = [],
        mGeoSearchThreshold = 15.0,
        mHeatMapGradient = [
       'rgba(0, 255, 255, 0)',
       'rgba(0, 255, 255, 1)',
       'rgba(0, 191, 255, 1)',
       'rgba(0, 127, 255, 1)',
       'rgba(0, 63, 255, 1)',
       'rgba(0, 0, 255, 1)',
       'rgba(0, 0, 223, 1)',
       'rgba(0, 0, 191, 1)',
       'rgba(0, 0, 159, 1)',
       'rgba(0, 0, 127, 1)',
       'rgba(63, 0, 91, 1)',
       'rgba(127, 0, 63, 1)',
       'rgba(191, 0, 31, 1)',
       'rgba(255, 0, 0, 1)'
        ],
        mInfoWindow = null;
    if (!this.isNothing(aOptions)) {
        if (aOptions.displayType) {
            mDisplayType = aOptions.displayType;
        }
        if (aOptions.mapTypeId_OnChange) {
            mMapTypeId_OnChange = aOptions.mapTypeId_OnChange;
        }
        //Distance Test
        mMap_OnClick = aOptions.OnClick;
        mMap_OnRightClick = aOptions.OnRightClick;
    }

    

    this.layerAdd = function (aName, aOptions) {
        var lLayer = new sumo.maps.Layer(aName, mMap, aOptions);
        mLayers[aName] = lLayer;
        if (lLayer.isVisible()) {
            lLayer.show();
        }
    };

    this.layerRemove = function (aLayerName) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            lLayer.dispose();
            mLayers.splice(mLayers.indexOf(lLayer), 1);
        }
    };

    this.getPlaybackController = function (aLayerName, aOptions) {
        var lKeyLayer = mLayers[aLayerName],
            lSupportLayers = [],
            lKey,
            lLayer,
            lResult = null;
        if (!this.isNothing(lKeyLayer)) {
            for (lKey in mLayers) {
                if (mLayers.hasOwnProperty(lKey)) {
                    lLayer = mLayers[lKey];
                    if (lLayer.doesPlayback() === true && lLayer.name() !== aLayerName) {
                        lSupportLayers.push(lLayer);
                    }
                }
            }
            lResult = new sumo.maps.Playback(lKeyLayer, lSupportLayers, aOptions);
        }
        return lResult;
    };

    this.layerGetShape = function (aLayerName, aShapeId) {
        var lResult = null,
            lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            lResult = lLayer.getShape(aShapeId);
        }
        return lResult;
    };

    this.layerShow = function (aLayerName) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            lLayer.show();
        }
    };

    this.layerHide = function (aLayerName) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            lLayer.hide();
        }
    };

    this.layerSetDataSource = function (aLayerName, aDataSource) {
        var lLayer = mLayers[aLayerName];
        if (mInfoWindow !== null) {
            mInfoWindow.close();
        }
        if (!this.isNothing(lLayer)) {
            lLayer.setDataSource(aDataSource);
        }
    };

    this.layerGetDataSource = function (aLayerName) {
        var lLayer = mLayers[aLayerName];
        var lData = [];
        if (!this.isNothing(lLayer)) {
            lData = lLayer.getDataSource();
        }

        return lData;
    };

    this.layerSetRenderType = function (aLayerName, aRenderType) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            lLayer.setRenderType(aRenderType);
        }
    };

    this.layerSetDragEndHandler = function (aLayerName, aCallback) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            lLayer.dragEndHandler(aCallback);
        }
    };

    this.layerSetDoesPlayback = function (aLayerName, aDoesPlayback) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            lLayer.setDoesPlayback(aDoesPlayback);
        }
    };

    this.hideInfo = function () {
        if (mInfoWindow !== null) {
            mInfoWindow.close();
        }
    };

    this.showInfo = function (aAnchor, aHtmlContent, aLatitude, aLongitude) {
        if (mInfoWindow !== null) {
            mInfoWindow.close();
        }
        mInfoWindow = new google.maps.InfoWindow({
            'content': aHtmlContent,
            'position': new google.maps.LatLng(aLatitude, aLongitude),
            'zIndex': 10000000,
            'anchor': aAnchor
        });
        mInfoWindow.open(mMap, aAnchor);
    };

    function window_OnResize() {
        if (!mThis.isNothing(mMap)) {
            google.maps.event.trigger(mMap, 'resize');
        }
    }


    this.zoom = function (aLevel) {
        mMap.setZoom(aLevel);
    };

    this.getZoom = function(){
       return mMap.getZoom();
    };

    this.resize = function () {
        window_OnResize();
    }

    this.render = function () {
        var lDisplayType = google.maps.MapTypeId.HYBRID,
            lControlPosition = google.maps.ControlPosition.TOP_RIGHT;
        if (mDisplayType === 'roadmap') {
            lDisplayType = google.maps.MapTypeId.ROADMAP;
        } else if (mDisplayType === 'satellite') {
            lDisplayType = google.maps.MapTypeId.SATELLITE;
        } else if (mDisplayType === 'terrain') {
            lDisplayType = google.maps.MapTypeId.TERRAIN;
        }
        mMap = new google.maps.Map(this.ControlElement[0], {
            'zoom': 3,
            'center': new google.maps.LatLng(27.9709, -82.4646),
            'zoomControl': true,
            'zoomControlOptions': {
                position: lControlPosition
            },
            'streetViewControlOptions': {
                position: lControlPosition
            },
            'rotateControlOptions': {
                position: lControlPosition
            },
            'mapTypeId': lDisplayType,
            'styles': [{
                'featureType': 'poi',
                'stylers': [{ visibility: 'on' }]
            }]
        });

        if (!mThis.isNothing(mMapTypeId_OnChange)) {
            google.maps.event.addListener(mMap, 'maptypeid_changed', function () { mMapTypeId_OnChange(mMap); });
        }
        //Distance Test
        google.maps.event.addListener(mMap, 'click', function (event) {
            if (!mThis.isNothing(mMap_OnClick)) {
                mMap_OnClick(event);
            }
        });

        google.maps.event.addListener(mMap, "rightclick", function (event) {
            setTimeout(function(){
                if (!mThis.isNothing(mMap_OnRightClick)) {
                    mMap_OnRightClick(event);
                }
            }, 0, event);
            
        });
        mMap.sumoData = this;
        $(window).resize(window_OnResize);

        this.trigger('render');
    };

    this.getMap = function () {
        return mMap;
    };

    this.getCenter = function () {
        var lResult = null;
        if (!this.isNothing(mMap)) {
            lResult = mMap.getCenter();
        }
        return lResult;
    };

    this.setCenter = function (aLatitude, aLongitude) {
        if (!this.isNothing(mMap)) {
            mMap.setCenter(new google.maps.LatLng(aLatitude, aLongitude));
        }
    };

    this.getBoundsFromArray = function (aLatLonArray) {
        var lResult = new google.maps.LatLngBounds(),
            lIndex = 0,
            lLatLng = null,
            lLength = aLatLonArray.length;

        for (lIndex = 0; lIndex < lLength; lIndex++) {
            if (aLatLonArray[lIndex].latitude && aLatLonArray[lIndex].longitude) {
                lLatLng = new google.maps.LatLng(aLatLonArray[lIndex].latitude, aLatLonArray[lIndex].longitude);
                lResult.extend(lLatLng);
                lLatLng = null;
            }
        }

        return lResult;
    };

    this.fitBounds = function (aLatLngBounds) {
        var lKey,
            lLayer,
            lMapBounds = new google.maps.LatLngBounds();

        if (this.isNothing(aLatLngBounds)) {
            for (lKey in mLayers) {
                if (mLayers.hasOwnProperty(lKey)) {
                    lLayer = mLayers[lKey];
                    if (!this.isNothing(lLayer)) {
                        lMapBounds = lLayer.fitBounds(lMapBounds);
                    }
                }
            }
        } else {
            lMapBounds = aLatLngBounds;
        }
        mMap.fitBounds(lMapBounds);
    };

    function locateResult(aResult, aStatus, aCallback) {
        if (aResult) {
            mThis.setCenter(aResult.center_latitude, aResult.center_longitude);
            if (!mThis.isNothing(aCallback)) {
                aCallback('Geocode', aResult);
            }
        } else {
            if (!mThis.isNothing(aCallback)) {
                aCallback('Geocode', null);
            }
        }
    }
    //TESTING PLACES LIBRARY 
    function placesCallBack(aResults, aStatus) {
        var lPlaceList = [],
            lPlace,
            i;
        if (aStatus === google.maps.places.PlacesServiceStatus.OK) {
            for (i = 0; i < aResults.length; i++) {
                lPlace = aResults[i];
                lPlaceList.push(lPlace);
            }
        }
        switch (mMap.b.id) {
            case 'uOffenderMap':
                enrolleesPlaces_OnComplete(lPlaceList);
                break;
            case 'uEventMap':
                eventsPlaces_OnComplete(lPlaceList);
                break;
            case 'uAnalysisDetailsMap':
                analysisPlaces_OnComplete(lPlaceList);
                break;
            case 'uZoneMap':
                zonesPlaces_OnComplete(lPlaceList);
                break;
        }
    }

    this.latLngLocate = function (aLat, aLng) {
        var geocoder = new google.maps.Geocoder(),
            input = aLat + ',' + aLng,
            latlngStr = input.split(",", 2),
            lat = parseFloat(latlngStr[0]),
            lng = parseFloat(latlngStr[1]),
            latlng = new google.maps.LatLng(lat, lng);
        function OnLocalGeocodeSuccess(aParams, aData) {
            if (!isNullOrUndefined(aData)) {
                return aData.formated_address;
            } else {
                geocoder.geocode({ 'latLng': latlng }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        if (results) {
                            return results.formated_address;
                        }
                    } else {
                        alert("Geocoder failed due to: " + status);
                    }
                });
            }           
        }
        ReverseGeoCodeAddress(aLat, aLng, OnLocalGeocodeSuccess, function () {
            OnLocalGeocodeSuccess(null, [])
        }, { 'latlng': latlng });
    };
   
    this.geocode = function (aAddress, aCallback, aParams) {
        var lGeocoder = new google.maps.Geocoder(),
            latlngStr = aAddress.split(",", 2),
            lat = parseFloat(latlngStr[0]),
            lng = parseFloat(latlngStr[1]),
            latlng = new google.maps.LatLng(lat, lng),
            lRequest = { 'latLng': latlng };

        function success(aResult, aStatus, aResponseType) {
            if (aResult &&  !isNullOrUndefined(aResponseType)) {
                var lAddress = new Address(aResult);
                var latlng1 = { 'lat': aResult.center_latitude, 'lng': aResult.center_longitude };
                var latlng2 = { 'lat': aResult.location.coordinates[0][0][1], 'lng': aResult.location.coordinates[0][0][0]};
                lAddress.Radius = GeodesicDistance(latlng1, latlng2);            
                var lGlobalAddress = new GlobalAddress(lAddress);
                lGlobalAddress.AddressTypeId = 3;
                lGlobalAddress.Name = 'Map Geocode';
                WriteSingle(lGlobalAddress, null, null, null, true);
            }
            aCallback(aResult, aStatus, aParams);
        }

        function OnLocalGeocodeSuccess(aParams, aData) {
            if (!isNullOrUndefined(aData)) {
                success(aData, google.maps.GeocoderStatus.OK, 'LocalGeocode');
               /*  var lResultHits = aData.hits.hits;
                var lLocalResults = formatElasticAddressResults(lResultHits);
                if (lLocalResults == null) {
                    lGeocoder.geocode(lRequest, success);
                } else {
                    success(lLocalResults, google.maps.GeocoderStatus.OK, 'LocalGeocode');
                }   */              
            } else {
                lGeocoder.geocode(lRequest, success);
            }
        }
       
        if (isNaN(latlng.lat())) {
            lRequest = { 'address': aAddress }
        }

        if (!this.isNothing(aAddress)) {
            ReverseGeoCodeAddress(lat, lng, OnLocalGeocodeSuccess, function () {
                OnLocalGeocodeSuccess(null, [])
            }, { 'latlng': latlng });            
        }
    };
    /**
     * Reverse geocode in order to translate a location on the map into a human-readable address
     * @name reverseGeocode
     * @param {string} aLatitude - a Latitude value in String format
     * @param {string} aLongitude - a Longitude  value in String format
     * @param {Function} CallbackCb - Callback function that returns fn(address,status)
    */
    this.reverseGeocode = function(aLatitude,aLongitude,CallbackCb){
        this.geocode(aLatitude + ', ' +  aLongitude
            ,function(address,status,params){
                var list = {};
                if(status === 'OK'){
                    var a = new Address(address);
                    CallbackCb({
                        Description:address.formated_address,
                        Street1: a.StreetNumber + " " + a.Street1,
                        Street2: a.Street2,
                        City: a.City,
                        State: a.State,
                        Zip: a.ZipCode,
                        Country:a.Country
                    },status)
                }else { 
                    CallbackCb({
                        Street1: '',
                        Street2: '',
                        City: '',
                        State: '',
                        Zip: '',
                        Country:'',
                    },status)
                }
            });
        
    }
    this.locate = function (aAddress, aCallback) {
        var lGeocoder = new google.maps.Geocoder(),
            lRequest = { 'address': aAddress },
            lMatch = aAddress.match(/-?\d+\.\d+/g),
            lCallback;

        function OnLocalReverseGeocodeSuccess(aParams, aData) {
            if (!isNullOrUndefined(aData)) {
                locateResult(aData, 'OK', aCallback);
                /* var lResultHits = aData.hits.hits;
                var lGeoResults = formatElasticAddressResults(lResultHits);
                if (lGeoResults == null) {
                    lCallback = function (aResult, aStatus) {
                        locateResult(aResult, aStatus, aCallback);
                    };
                    lGeocoder.geocode(aParams, lCallback);
                } else {
                    locateResult(lGeoResults, 'OK', aCallback);
                }  */               
                
            } else {
                lCallback = function (aResult, aStatus) {
                    locateResult(aResult, aStatus, aCallback);
                };
                lGeocoder.geocode(aParams, lCallback);
            }
            
        }

        if (this.isNothing(lMatch) || lMatch.length !== 2) {           
            GeoCodeAddress(aAddress, OnLocalReverseGeocodeSuccess, function () {
                OnLocalReverseGeocodeSuccess(lRequest, [])
            }, lRequest);
            
        } else {
            this.setCenter(lMatch[0], lMatch[1]);
            if (!isNullOrUndefined(aCallback)) {
                aCallback('LatLong', { 'Latitude': lMatch[0], 'Longitude': lMatch[1] });
            }
        }
    };
    //TESTING PLACES LIBRARY 
    this.locatePlaces = function (aAddress, aCallback) {
        var lRequest,
            lService,
            lMapCenter = mMap.getCenter(),
            lLatitude = lMapCenter.lat(),
            lLongitude = lMapCenter.lng(),
            lLocation = new google.maps.LatLng(lLatitude, lLongitude);


        lRequest = {
            location: lLocation,
            radius: '300',
            query: aAddress
        };
        lService = new google.maps.places.PlacesService(mMap);
        lService.textSearch(lRequest, placesCallBack);
    };

    this.clearStreetView = function () {
        var lPanorama = mMap.getStreetView();

        lPanorama.setVisible(false);
    };

    function navigateToStreetView(aLatLng) {
        var lPanorama;
        lPanorama = mMap.getStreetView();
        lPanorama.setPosition(aLatLng);
        lPanorama.setPov({
            heading: 265,
            pitch: 0
        }
        );
        lPanorama.setVisible(true);
    };

    this.setStreetLevel = function (aLatitude, aLongitude, aPlaceMarker) {
        var lStreetViewService = new google.maps.StreetViewService(),
            lStreetViewMaxDistance = 100,
            lLatLng = new google.maps.LatLng(aLatitude, aLongitude),
            lPanorama,
            lMessage;

        if (aPlaceMarker) {
            var marker = new google.maps.Marker({
                position: lLatLng,
                map: mMap,
                icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
            });
        }    

        lStreetViewService.getPanoramaByLocation(lLatLng, lStreetViewMaxDistance, function (aStreetViewPanoramaData, aStatus) {
            if (aStatus === google.maps.StreetViewStatus.OK) {
                navigateToStreetView(aStreetViewPanoramaData.location.latLng);
            } else {
                mThis.trigger('streetviewerror', 'Street View Unavailable');
                lPanorama = mMap.getStreetView();
                lPanorama.setVisible(false);
            }
        });
    };

    this.boundsChanged = function () {
        google.maps.event.trigger(mMap, 'resize');
        //        google.maps.event.trigger(mMap, 'bounds_changed');
        //        google.maps.event.trigger(mMap, 'projection_changed');
    };
    this.isLayerNotAvailable = function(aLayerName){
        return this.isNothing(mLayers[aLayerName])
    }
    this.dispose = function () {
        var lKey = null,
            lLayer = null;

        if (mInfoWindow !== null) {
            mInfoWindow.close();
        }
        for (lKey in mLayers) {
            if (mLayers.hasOwnProperty(lKey)) {
                lLayer = mLayers[lKey];
                if (!this.isNothing(lLayer)) {
                    lLayer.dispose();
                    mLayers[lKey] = null;
                }
            }
        }
        mLayers = null;

        $(window).unbind('resize', window_OnResize);
        google.maps.event.clearListeners(mMap);
        mMap = null;

        mThis = null;
        sumo.maps.GoogleMapControl.prototype.dispose.call(this);
    };

    this.getHeatMapDataPoints = function () {
        return mHeatMapData;
    };

    this.setHeatMapDataPoints = function (aDataSet) {
        mHeatMapData = [];
        if (aDataSet != null) {
            for (var key in aDataSet) {
                if (aDataSet.hasOwnProperty(key)) {                    
                    mHeatMapData.push(new google.maps.LatLng(aDataSet[key].Latitude, aDataSet[key].Longitude));
                }                
            }           
        }

        if (!isNullOrUndefined(mHeatMap)) {
            mHeatMap.set('data', mHeatMapData);
        }
        
    };

    this.changeHeatMapGradient = function () {       
        mHeatMap.set('gradient', mHeatMap.get('gradient') ? null : mHeatMapGradient);
    };

    this.getHeatMap = function () {
        return mHeatMap;
    };

    this.toggleHeatMap = function () {
        if (mHeatMap == null) {
            mHeatMap = new google.maps.visualization.HeatmapLayer({
                data: mHeatMapData,
                map: mMap
            });

            mHeatMap.set('gradient', mHeatMap.get('gradient') ? null : mHeatMapGradient);
            
        } else {
            mHeatMapData = [];
            mHeatMap.setMap(null);
            mHeatMap = null;
        }
    };

    this.changeRadius = function (aRadius) {
        mHeatMap.set('radius', mHeatMap.get('radius') ? null : aRadius);
    };

    this.disposeHeatMap = function () {
        mHeatMapData = [];
        if (mHeatMap != null) {
            mHeatMap.setMap(null);
            mHeatMap = null;
        }
       
    };

    this.changeOpacity = function (aOpacity) {
        mHeatMap.set('opacity', mHeatMap.get('opacity') ? null : aOpacity);
    };

    this.render();
};
sumo.maps.GoogleMapControl.prototype = new sumo.controls.ControlBase();
sumo.maps.GoogleMapControl.prototype.constructor = sumo.maps.GoogleMapControl;
sumo.maps.GoogleMapControl.prototype.baseClass = sumo.controls.ControlBase;